export const SET_LOADING_REDIRECTS = 'REDIRECTS_SET_LOADING_REDIRECTS';
export const LOAD_REDIRECTS = 'REDIRECTS_LOAD_REDIRECTS';
export const SET_CREATING_REDIRECT = 'REDIRECTS_SET_CREATING_REDIRECT';
export const CREATE_REDIRECT = 'REDIRECTS_CREATE_REDIRECT';
export const SET_UPDATING_REDIRECT = 'REDIRECTS_SET_UPDATING_REDIRECT';
export const UPDATE_REDIRECT = 'REDIRECTS_UPDATE_REDIRECT';
export const SET_DELETING_REDIRECT = 'REDIRECTS_SET_DELETING_REDIRECT';
export const DELETE_REDIRECT = 'REDIRECTS_DELETE_REDIRECT';
export const RESET = 'REDIRECTS_RESET';